module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-wasou-costume-c44b11f9fd24ae430b266c56cb775758.jpg";